import { Injectable } from '@angular/core';

import { UtilityService } from './utility.service';

@Injectable()
export class OfficeHomeUtilityService implements UtilityService {

    public isSurfaceDevice(): boolean {
        return false;
    }
}
